import React from "react";
import { Box, Text, Flex } from "@chakra-ui/react";
import SessionChart from "./SessionChart";
import ChartLegend from "./ChartLegend";

interface SessionOverviewProps {
  title?: string;
  totalSessions?: number;
  data?: Array<{ month: string; count: number }>;
}

const SessionOverview: React.FC<SessionOverviewProps> = ({
  title = "Sessions Overview",
  totalSessions = 1342,
  data = [
    { month: "Jan", count: 18 },
    { month: "Feb", count: 22 },
    { month: "Mar", count: 26 },
    { month: "Apr", count: 28 },
    { month: "May", count: 30 },
    { month: "Jun", count: 32 }
  ]
}) => {
  return (
    <Box width="100%">
      <Text fontSize="lg" fontWeight="medium" mb={2}>{title}</Text>
      
      <Flex align="center">
        <Text fontSize="5xl" lineHeight="1" color="blue.500" fontWeight="medium">
          {totalSessions}
        </Text>
        <Text ml={2} mt={4} color="gray.600">Total Sessions</Text>
      </Flex>
      
      <Box 
        mt={4} 
        width="100%" 
        h="calc(100% - 100px)" 
        minH="220px"
        px={0}
      >
        <SessionChart data={data} height="180px" />
        <ChartLegend />
      </Box>
    </Box>
  );
};

export default SessionOverview; 